import React from 'react';
import { IStudyHistory } from 'types';
import { formatAddress } from '../../helpers';
import { CustomCollapse } from '@/components/CustomCollapse/CustomCollapse';
import Field from '@/components/Field/Field';
import { Qualifications } from './Qualifications';

export interface IHighestStudyProps {
  studyHistoryCurrent: IStudyHistory;
  studyHistoryInitial: IStudyHistory;
}

/**
 * Component to display the highest study level between two study histories.
 * It compares the highest level of education from both studies and displays the one that is higher.
 **/
export function HighestStudy(props: IHighestStudyProps): React.ReactElement {
  const { studyHistoryCurrent, studyHistoryInitial } = props;

  // Determine the highest study level from both studies
  const highestStudyCurrent = studyHistoryCurrent?.highest;
  const highestStudyInitial = studyHistoryInitial?.highest;

  const header = highestStudyCurrent?.institutionName || highestStudyInitial?.institutionName || 'Unknown institution';

  const institutionNameCurrent = highestStudyCurrent?.institutionName;
  const institutionNameInitial = highestStudyInitial?.institutionName;

  const countryCurrent = highestStudyCurrent?.country;
  const countryInitial = highestStudyInitial?.country;

  const addressCurrent = formatAddress({
    ...(highestStudyCurrent?.institutionAddress ?? {}),
    country: highestStudyCurrent?.country,
  });

  const addressInitial = formatAddress({
    ...(highestStudyInitial?.institutionAddress ?? {}),
    country: highestStudyInitial?.country,
  });

  return (
    <CustomCollapse defaultIsOpen key={`highest-study`}>
      {/* Step 1: Institution (top level) - School or University name */}
      <CustomCollapse.Trigger>{header}</CustomCollapse.Trigger>
      <CustomCollapse.Content>
        <Field leftLabel="Country" value={countryCurrent} originalValue={countryInitial} />
        <Field leftLabel="Institution" value={institutionNameCurrent} originalValue={institutionNameInitial} />
        <Field leftLabel="Address" value={addressCurrent} originalValue={addressInitial} />

        <Qualifications studyCurrent={highestStudyCurrent} studyInitial={highestStudyInitial} />
      </CustomCollapse.Content>
    </CustomCollapse>
  );
}
